import { createSlice } from '@reduxjs/toolkit';
import { ILetter } from 'Shared/Types/letter';
import { sendLetter } from './reducer';
import { RootState } from 'Redux/store';

interface ILetterState {
  sentLetter?: ILetter;
  error?: string | null;
  loading: boolean;
}

const initialState: ILetterState = {
  loading: false,
  error: null,
};

const letterSlice = createSlice({
  name: 'letter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sendLetter.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(sendLetter.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(sendLetter.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.sentLetter = action.payload;
    });
  },
});

export const selectLetterLoading = (state: RootState) => state.letter.loading;
export const selectLetterError = (state: RootState) => state.letter.error;
export const selectSentLetter = (state: RootState) => state.letter.sentLetter;

export default letterSlice;
